import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";

import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

function HospitalEdit() {
  const [loading, setLoading] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const [hospital_name, setHospitalName] = useState(location.state.hospital_name);
  const [hospital_code, setHospitalCode] = useState(location.state.hospital_code);
  const [info, setInfo] = useState({});
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const user = useSelector(getUser);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await api.findHospital(null, null, hospital_code);
    setLoading(false);
    if (res) {
      if (res['data']['code'] === 200) {
        setInfo(res['data']['data'][0]);
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handlePrevious = () => {
    navigate('/hospitalManager');
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    if (!hospital_name.trim() || !hospital_code.trim()) {
      handleError("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }
    setShowUpdateModal(true); 
  };

  const confirmedUpdate = async () => {
    let body = { ...info };
    body.hospital_code = hospital_code;
    body.hospital_name = hospital_name;
    body.updated_date = new Date().toISOString();
    body.updated_user = JSON.parse(localStorage.getItem('userData'))?.uid; 

    setLoading(true);
    const res = await api.updateHospital(body);
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        handlePrevious() //navigate
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);

  return (
    <>
      <Loader loading={loading} />
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะแก้ไขข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการโรงพยาบาล
      </Box>
      <Box className={styles.head1Text}>แก้ไขข้อมูลโรงพยาบาล</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อโรงพยาบาล</Box>
        <InsertBar
          currentValue={hospital_name}
          setNewValue={setHospitalName}
          placeholder="ชื่อโรงพยาบาล"
        />
        {/* <Box className={styles.head2Text} sx={{marginTop: 1}}>รหัสโรงพยาบาล</Box> */}
        {/* <InsertBar
          currentValue={hospital_code}
          setNewValue={setHospitalCode}
          placeholder="รหัสโรงพยาบาล"
        /> */}
        {/* <Box  
          className={styles.bodyText}
          sx={{
            padding: '14px 24px', 
            border: '1px solid #ccc', 
            borderRadius: '4px', 
            color: '#555',
          }}
        >
          {hospital_code}
        </Box> */}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2, marginRight: 4.3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default HospitalEdit;
